interface OverwriteElement extends HTMLElement {
  dataset: {
    overwriteSectionId?: string;
    overwriteIsSticky?: string;
  };
}

const initOverwriteBars = () => {
  document
    .querySelectorAll<OverwriteElement>("[data-overwrite-section-id]")
    .forEach((overwriteSection) => {
      const sectionId = overwriteSection.dataset.overwriteSectionId;
      if (!sectionId) return;
      const stickyEnabled = overwriteSection.dataset.overwriteIsSticky === "true";
      const barElement = document.getElementById(
        `announcement-bar-${sectionId}`,
      );
      if (!barElement) return;

      const updateHeightAndSticky = (visible: boolean) => {
        if (stickyEnabled && visible) {
          const height = Math.round(barElement.clientHeight) + "px";
          document.documentElement.style.setProperty(
            "--announcement-bar-height",
            height,
          );
          document.documentElement.style.setProperty(
            "--sticky-announcement-bar-enabled",
            "1",
          );
        } else {
          document.documentElement.style.setProperty(
            "--announcement-bar-height",
            "0px",
          );
          document.documentElement.style.setProperty(
            "--sticky-announcement-bar-enabled",
            "0",
          );
        }
      };

      updateHeightAndSticky(barElement.getBoundingClientRect().bottom > 0);

      const intersectionObserver = new IntersectionObserver(
        ([entry]) => {
          updateHeightAndSticky(entry.intersectionRatio > 0);
        },
        { threshold: [0] },
      );
      intersectionObserver.observe(barElement);

      const sectionElement = barElement.closest(".shopify-section");
      if (sectionElement) {
        const onUnload = () => {
          intersectionObserver.disconnect();
          sectionElement.removeEventListener("shopify:section:unload", onUnload);
        };
        sectionElement.addEventListener("shopify:section:unload", onUnload);
      }

      window.addEventListener("beforeunload", () => intersectionObserver.disconnect());
    });
};

document.addEventListener("DOMContentLoaded", initOverwriteBars);
